import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "value", "maxlength"]

import { withDefaults } from "vue"

interface MyInputProps {
  value?: string;
  type?: string;
  maxLength?: number;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    value: null,
    type: { default: "text" },
    maxLength: { default: 100 }
  },
  emits: ["input-text"],
  setup(__props: any, { emit }) {






function inputText(e: Event) {
  const el = e?.target as HTMLInputElement;
  emit("input-text", el?.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      type: __props.type,
      class: "rounded border border-palette2 w-full p-3 mx-auto",
      value: __props.value,
      onInput: inputText,
      placeholder: "",
      maxlength: __props.maxLength
    }, null, 40, _hoisted_1)
  ]))
}
}

})